export enum LivechatChildEvent {
  REDIRECT_TO_PLATFORM = 'redirect_to_platform',
}
